import React, { useState, useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Spinner } from 'react-bootstrap';
import { Login } from './components/Login';
import { AdminLayout } from './components/AdminLayout';
import { Dashboard } from './pages/Dashboard';
import { EmailsPage } from './pages/EmailsPage';
import { ActionLogsPage } from './pages/ActionLogsPage';
import { authService } from './services/auth';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [loginError, setLoginError] = useState<string>('');

  useEffect(() => {
    const loggedIn = authService.isLoggedIn();
    setIsAuthenticated(loggedIn);
    setIsLoading(false);
  }, []);

  const handleLogin = async (username: string, password: string) => {
    setLoginError('');
    const success = await authService.login(username, password);
    if (success) {
      setIsAuthenticated(true);
    } else {
      setLoginError('Invalid username or password');
    }
  };

  const handleLogout = () => {
    authService.logout();
    setIsAuthenticated(false);
  };

  if (isLoading) {
    return (
      <div
        className="min-vh-100 d-flex flex-column align-items-center justify-content-center bg-light"
      >
        <Spinner animation="border" variant="primary" style={{ width: '3rem', height: '3rem' }} />
        <p className="mt-3 text-muted fw-semibold">Loading...</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Login onLogin={handleLogin} error={loginError} />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route element={<AdminLayout onLogout={handleLogout} />}>
          <Route index element={<Dashboard />} />
          <Route path="/emails" element={<EmailsPage />} />
          <Route path="/logs" element={<ActionLogsPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;
